import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useEffect } from "react";
import ValueCard from "./card_value";

export default function ValuesCarrousel() {
  const valores = [
    { title: "Respeto", text: "Tratamos a clientes y empleados con dignidad." },
    { title: "Honestidad", text: "Operamos con transparencia y compromiso ético." },
    { title: "Compromiso", text: "Brindamos protección con responsabilidad." },
    { title: "Innovación", text: "Buscamos mejorar constantemente nuestros servicios." },
    { title: "Excelencia", text: "Nos esforzamos por ofrecer un servicio impecable." },
  ];

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    mode: "free",
    slides: { perView: 4, spacing: 10 },
    breakpoints: {
      "(max-width: 1024px)": { slides: { perView: 3, spacing: 10 } },
      "(max-width: 768px)": { slides: { perView: 2, spacing: 8 } },
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      instanceRef.current?.next();
    }, 3000);

    return () => clearInterval(interval);
  }, [instanceRef]);

  return (
    <div ref={sliderRef} className="keen-slider w-full scrollbar-hide">
      {valores.map((value, index) => (
        <div key={index} className="keen-slider__slide">
          <ValueCard text={value.text} title={value.title} />
        </div>
      ))}
    </div>
  );
}
